import {values} from 'lodash'

export default {
    data() {
        return {
            selected: {}
        }
    },
    computed: {
        selectedItems() {
            return this.results ? this.results.results.filter(i => this.selected[i.id]) : []
        },
        checkedStatus: {
            get() {
                if (this.results) {
                    return this.results && this.results.total > 0 &&
                        (this.results.total === values(this.selected).filter(i => i).length ||
                        this.results.limit === values(this.selected).filter(i => i).length)
                }

                return false
            },
            set(value) {
                if (this.hasResults) {
                    if (value === true) {
                        for (let i in this.results.results) {
                            this.$set(this.selected, this.results.results[i].id, true)
                        }
                    } else {
                        for (let i in this.results.results) {
                            this.$set(this.selected, this.results.results[i].id, false)
                        }
                    }
                }
            }
        }
    },
    methods: {
        select() {
            for (let i in this.selected) {
                this.selected[i] = true
            }
        },
        unselect() {
            for (let i in this.selected) {
                this.selected[i] = false
            }
        },
    }
}